module.exports = __webpack_public_path__ + "static/media/06.7c3dc1b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/dayup/home/06.png
// module id = 798
// module chunks = 0